import { useCallback } from "react";

export const useSessionStorage = () => {
    const setSessionStorage = useCallback(<T>(key: string, value: T): void => {
        try {
            const serializedValue = JSON.stringify(value);

            sessionStorage.setItem(key, serializedValue);
        } catch (error) {
            console.error(`Error storing item with key "${key}" in session storage:`, error);
        }
    }, []);

    const getSessionStorage = useCallback(<T>(key: string, defaultValue?: T): T | null => {
        try {
            const serializedValue = sessionStorage.getItem(key);
            if (serializedValue === null) {
                return defaultValue ?? null;
            }

            return JSON.parse(serializedValue) as T;
        } catch (error) {
            console.error(`Error retrieving item with key "${key}" from session storage:`, error);

            return defaultValue ?? null;
        }
    }, []);

    const removeSessionStorage = useCallback((key: string): void => {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing item with key "${key}" from session storage:`, error);
        }
    }, []);

    const clearSessionStorage = useCallback((): void => {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error("Error clearing session storage:", error);
        }
    }, []);

    return {
        setSessionStorage,
        getSessionStorage,
        removeSessionStorage,
        clearSessionStorage,
    };
};
